module.exports = __webpack_public_path__ + "img/pauli-x-root-33.75e616a4.svg";